export default "__VITE_ASSET__CXMbLTRJ__"